// utils/globalMethods.js
export default {
  greet(name) {
    return `Hello, ${name}!`
  },
  parseErrors(errorInput) {
    let errors = {};

    // If input is a string, try parsing it
    if (typeof errorInput === 'string') {
      try {
        errors = JSON.parse(errorInput);
      } catch (e) {
        // It's a plain string, return as-is
        return errorInput;
      }
    } else if (typeof errorInput === 'object' && errorInput !== null) {
      errors = errorInput;
    } else {
      return 'Unknown error format';
    }

    // Now format like before
    return Object.entries(errors)
      .map(([field, messages]) => {
        const label = field.replace(/\.\d+\./g, ' → ').replace(/\./g, ' ');
        // return `${messages.join(', ')}`;
        return `<b>${label}</b>: ${messages.join(', ')}`;
      })
      .join('<br>');
  },
}
